// In-memory holder for the bearer token. The http provider reads it to set
// the `Authorization` header on every request; the auth store writes it on
// sign-in/out and on rehydration of the persisted session. Keeping it here
// (rather than reaching into the store) preserves the rule that `src/api` is
// the only network seam and never imports from `src/store`.
let token: string | null = null;

export const getAuthToken = (): string | null => token;

export const setAuthToken = (next: string | null): void => {
	token = next;
};

// Вход истёк или отозван (консоль живёт 12 часов простоя и не дольше 7 дней,
// смена пароля гасит прежние входы): первый 401 при живом токене выводит на
// экран входа, а не оставляет страницу с ошибками. Обработчик ставит стор.
let onSessionExpired: (() => void) | null = null;

export const setSessionExpiredHandler = (handler: (() => void) | null): void => {
	onSessionExpired = handler;
};

/** Ответ 401 на запрос, ушедший с токеном `sentWith`. */
export const reportUnauthorized = (sentWith: string | null): void => {
	// Токен уже сменился (вошли заново) или его не было (неверный пароль на
	// экране входа) — это не истёкшая сессия.
	if (!sentWith || sentWith !== token) return;
	onSessionExpired?.();
};
